// Animate value proposition items: staggered fade-up, cascading within each parent block.
document.addEventListener( 'DOMContentLoaded', () => {
	const items = Array.from( document.querySelectorAll( '.valueproposition-item-block' ) );
	if ( ! items.length ) return;

	const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

	items.forEach( ( item ) => {
		item.style.opacity    = '0';
		item.style.transform  = 'translateY(40px)';
		item.style.transition = `opacity 0.65s ${ EASING }, transform 0.65s ${ EASING }`;
	} );

	// Batch items entering the viewport in the same tick so they stagger cleanly.
	let batchTimer = null;
	let batchQueue = [];

	const observer = new IntersectionObserver(
		( entries ) => {
			entries.forEach( ( entry ) => {
				if ( entry.isIntersecting ) {
					batchQueue.push( entry.target );
					observer.unobserve( entry.target );
				}
			} );

			clearTimeout( batchTimer );
			batchTimer = setTimeout( () => {
				batchQueue.forEach( ( el, i ) => {
					setTimeout( () => {
						el.style.opacity   = '1';
						el.style.transform = 'translateY(0)';
					}, i * 150 );
				} );
				batchQueue = [];
			}, 50 );
		},
		{ threshold: 0.25, rootMargin: '0px 0px -40px 0px' }
	);

	items.forEach( ( item ) => observer.observe( item ) );
} );
